var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.978,
    height: 21.7,
    viewBox: "0 0 24.978 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M.781,29.7a.781.781,0,0,1,.781.781v3.9a1.561,1.561,0,0,0,1.561,1.561H21.856a1.561,1.561,0,0,0,1.561-1.561v-3.9a.781.781,0,1,1,1.561,0v3.9a3.122,3.122,0,0,1-3.122,3.122H3.122A3.122,3.122,0,0,1,0,34.383v-3.9A.781.781,0,0,1,.781,29.7Z",
    transform: "translate(0 -15.806)",
    fill: "#00a3ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M18.41,19.945a.781.781,0,0,0,1.105,0L24.2,15.261a.782.782,0,1,0-1.105-1.105l-3.35,3.352V3.781a.781.781,0,1,0-1.561,0V17.508l-3.35-3.352a.782.782,0,1,0-1.105,1.105Z",
    transform: "translate(-6.474 -3)",
    fill: "#00a3ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4fa95296cfaea83db94adfd98d8ba714.svg";
export { ForwardRef as ReactComponent };